import React, { useState, useEffect, useContext } from 'react';
import $ from "jquery";
import { Col, Row, Container, Tabs, Tab } from 'react-bootstrap';
import FilterContextProvider, { FilterContext, FilterDispatchContext, initState } from "../context/FilterContext";
import UserContextProvider, { UserContext, UserDispatchContext } from "../context/UserContext";
import "font-awesome/css/font-awesome.css";
import NeuralNetwork_Tester from "./NeuralNetwork_Tester";
import { useParams } from 'react-router';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Map from "./Map"
import BaseStats from "./BaseStats"
import UnitStats from "./UnitStats"
import RankingStats from "./RankingStats"
import Chart from "./Chart"

function App() {
  const GetFilterData = () => {
    const filterState = useContext(FilterContext);
    const filterDispatchState = useContext(FilterDispatchContext);

    useEffect(() => {
      async function init() {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/filter-data`);
        filterDispatchState({
          ...filterState,
          filterData: (await response.json())
        });
      }
      init()
    }, [])
    return null
  }

  const VerifyApiKey = () => {
    const { apikey } = useParams();
    const userDispatchState = useContext(UserDispatchContext);

    useEffect(() => {
      async function init() {
        const url = process.env.REACT_APP_BACKEND_URL + `/apikeyCheck`
        const body = JSON.stringify({ apikey })
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body
        })
        const json = await response.json();
        userDispatchState(json);
      }
      init()
    }, [])

    return null
  }


  const TabsComponent = () => {
    const userState = useContext(UserContext);
    const filterState = useContext(FilterContext);
    const filterDispatchState = useContext(FilterDispatchContext);
    const [tab, setTab] = useState<String>("collected");

    return (
      <React.Fragment>
        <Tabs defaultActiveKey="collected"
          onSelect={(key) => {
            if (key) setTab(key);
            filterDispatchState({
              ...filterState,
              selectedPort: initState.selectedPort,
              selectedCategory: initState.selectedCategory,
              selectedType: initState.selectedType,
              selectedStartDate: initState.selectedStartDate,
              selectedEndDate: initState.selectedEndDate
            })
          }}>
          <Tab eventKey="collected" title="Recolhidas">
            <Row style={{ margin: "10px" }}>
              <div style={{ textAlign: "center" }}>
                <h2> Dados do Lixo Recolhido </h2>
              </div>
            </Row>
            <UnitStats sectionType={"collected"} />
            {
              userState.role === 'admin' &&
              <React.Fragment>
                <br />
                <Chart sectionType={"collected"} />
                <br />
                <Row style={{ margin: "10px" }}>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <h3> Mapa com localizações do lixo recolhido </h3>
                  </div>
                </Row>
              </React.Fragment>
            }
            {
              userState.role === 'admin' && <Map sectionType={tab}  withDateIntervalFilter={true}/>
            }
          </Tab>
          <Tab eventKey="delivered" title="Entregues">
            <Row style={{ margin: "10px" }}>
              <div style={{ textAlign: "center" }}>
                <h2> Dados do Lixo Entregue </h2>
              </div>
            </Row>
            <UnitStats sectionType={"delivered"} />
            {
              userState.role === 'admin' &&
              <React.Fragment>
                <Row style={{ margin: "10px" }}>
                  <div style={{ textAlign: "center" }}>
                    <h2> Classificações </h2>
                  </div>
                </Row>
                
                <br />
                <Chart sectionType={"delivered"} />
                <br />
                <Row style={{ margin: "10px" }}>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <h3> Mapa com localizações dos pontos de recolha com lixo entregue </h3>
                  </div>
                </Row>
              </React.Fragment>
            }
            {
              userState.role === 'admin' && <Map sectionType={tab}  withDateIntervalFilter={true} />
            }
          </Tab>
          <Tab eventKey="classifications" title="Classificações">
            <Row style={{ margin: "10px" }}>
                  <RankingStats sectionType={"delivered"} />
                </Row>
          </Tab>
        </Tabs>
        <Map sectionType={tab} withDateIntervalFilter={true}/>
      </React.Fragment>
    )
  }

  const DashBoard = () => {
    const userState = useContext(UserContext);

    if (userState.apikey) {
      return (
        <React.Fragment>
          <GetFilterData />
          <Container fluid>
            <Row style={{ margin: "10px" }}>
              <BaseStats />
            </Row>
            <TabsComponent />
          </Container>
        </React.Fragment>
      )
    } else {
      return null
    }

  }

  return (
    <FilterContextProvider>
      <UserContextProvider>
        <Router>
          <Switch>
            <Route exact path="/:apikey/dashboard">
              <VerifyApiKey />
              <DashBoard />
            </Route>
            <Route exact path="/map">
              <GetFilterData />
              <Map sectionType={"collected"} withDateIntervalFilter={false}/>
            </Route>
            <Route exact path="/neuralnetwork_tester">
              <NeuralNetwork_Tester />
            </Route>
          </Switch>
        </Router>
      </UserContextProvider>
    </FilterContextProvider>
  )
}

export default App;
